// removed by extract-text-webpack-plugin
module.exports = {"medium-grey":"#9f9f9f","background-grey":"#f6f6f6","black":"#000000","red":"#e40000","normal":".3s","fastest":".15s","desktop":"1366px","plp":"_3qqnBE69hFEFhTzd-JlXVe","container":"_1RnsXgGIGi11Qjzq66Igt1","information":"_2in4IJciBARlt9CBFGaJyt","aligned":"_1fl5czBrlUjw9Ar4nj4A5D","links":"_1hjSxKULoDN8HA_LAicnGV","linkItem":"_1i2XHVx2KFnBzfvkbKtbY6","link":"_1ohdARdGTw9mqlrE5mgaLc","socials":"Jg06WFANasML9RuYrIqGU","socialLink":"_3Q_3B9k5EJ1hTAVnkQfD-","socialIcon":"_3xgonUgWvORvk3LhqjE6IE"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Footer/ProductFooter/ProductFooter.css
// module id = 1201
// module chunks = 0